import { render, staticRenderFns } from "./BankTxList.vue?vue&type=template&id=12af0f3e&"
import script from "./BankTxList.vue?vue&type=script&lang=js&"
export * from "./BankTxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports